import { RESET_SHARED_DATA, SET_SHARED_DATA } from './constants';

export const setSharedData = (id: string, data: any) => ({
  type: SET_SHARED_DATA,
  id,
  data,
});

export const resetSharedData = (id: string) => ({
  type: RESET_SHARED_DATA,
  id,
});
